<!--this should be modified to show only forms (images shown on signup-login-reset-password.component.html)-->
<div style="position:absolute; right:0; top:0; padding:20px; z-index:1;">
	<div style="display: flex; align-items: center; justify-content: center;">
		<span *ngIf="allowCancel" (click)="cancel($event)" role="button" class="jmCloseBtn"></span>
	</div>
</div>
<div class="componentFormContainer">
	<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
	<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Sign into <span class="gColorAccentPrimary">Journeys</span>map</h1>
	<label for="txtU" class="form-label">Username or Email Address</label>
	<input #txtU
		   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
		   id="txtU"
		   type="text"
		   autocomplete="off"
		   autocapitalize="off"
		   class="form-control gFormInput"
		   maxlength="50"
		   placeholder="Username or Email Address"
		   [(ngModel)]="frmLogin.username"
		   (ngModelChange)="lookupZone($event)" />
	<label for="selZ" class="form-label">Select Zone</label>
	<div style="position: relative;">
		<select id="selZ" #selZ (change)="changeZone($event)" class="form-select gFormInput" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
			<option disabled selected hidden value="">Select Zone</option>
			<option *ngIf="frmLogin.zonesUpdating" selected value=""></option>			
			<ng-container *ngIf="!frmLogin.zonesUpdating">
				<option *ngFor="let zone of frmLogin.zones" [value]="zone.Client" [selected]="zone.Client===frmLogin.myZone">{{zone.DisplayName}}</option>
			</ng-container>
		</select>
		<div *ngIf="frmLogin.zonesUpdating" style="position: absolute; top: 10px; left: 10px;"><span class="jmWidgetLoadingIcon20"></span></div>
	</div>
	<label for="txtP" class="form-label">Password<span class="gColorAccentPrimary"> (Case Sensitive)</span></label>
	<div style="position: relative;">
		<input #txtP
			   id="txtP"
			   type="password"
			   autocomplete="off"
			   style="width: 100%;"
			   autocapitalize="off"
			   class="form-control gFormInput"
			   maxlength="50"
			   placeholder="Password"
			   [(ngModel)]="frmLogin.password"
			   (keydown)="submitLogin($event, null)" />
		<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPwType === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword((txtPwType==='password')?'text':'password')"></i>
	</div>
	<div [ngClass]="(!isLogging && msg !=='')?'':'hideClickable'" class="message" [innerHTML]="msg"></div>

	<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
		<div *ngIf="!isLogging" style="width: 100%;"><button type="button" class="btn btn-lg btn-primary" (click)="submitLogin($event, true)" [disabled]="!canLogin()" style="width: 100%;">Sign in</button></div>
		<div *ngIf="isLogging"><span class="jmWidgetLoadingIcon20"></span></div>
	</div>

	<div style="text-align: center; margin-bottom: 10px;">
		Don't have an account? Creating one is free! Sign up <a href="javascript:void(0);" (click)="createAccount($event)">here</a>.
	</div>
	<div style="text-align: center; margin-bottom: 20px;">
		Forgot your password? Click <a href="javascript:void(0);" (click)="resetPassword($event)">here</a>.
	</div>
</div>
